import { string } from 'prop-types';
import React from 'react';

import { BackButton } from '@components/buttons/BackButton';

const PageTitle = ({ title, source }) => {
	return (
		<div className="page-title-area pb-2 d-flex align-items-center align-self-center">
			<BackButton redirectPage={{ url: '/trends', sourceState: source }} />
			<h1 className="semibold-16 ml-2">{title}</h1>
		</div>
	);
};
PageTitle.propTypes = {
	title: string
};

export default PageTitle;
